export const useBox = () => {
  const toggleClose = (e) => {
    e.target.parentElement.classList.toggle("closed");
  };
  return {
    toggleClose,
  };
};
